module.exports = __webpack_public_path__ + "img/logo.bced288d.svg";